import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LoaderService } from 'src/app/core/loader.service';

@Component({
  selector: 'eos-image-viewer',
  templateUrl: './image-viewer.component.html',
  styleUrls: ['./image-viewer.component.css']
})
export class ImageViewerComponent implements OnInit {

  @Input() imageSrc = '';
  title = '';

  constructor(
    private loader: LoaderService,
    public modal: NgbActiveModal
  ) {
  }

  ngOnInit() { }
}
